import React from "react";
import { cn, RazorCopyFunction, trimLongString } from "../helper/helper";
import { Column } from "../stacks/index";

export interface TwinValueProps {
  one: string | React.ReactNode;
  two?: string | React.ReactNode;
  copy?: boolean;
  className?: string;
  twinClassNames?: {
    one?: string;
    two?: string;
  };
  gap?: number;
  textToCopy?: string;
  onTwoClick?: any;
  style?: React.CSSProperties;
  stopPropagation?: boolean;
}

const RazorTwinValue = ({
  one,
  two,
  className,
  twinClassNames,
  style,
  copy,
  gap,
  textToCopy,
  onTwoClick,
  stopPropagation,
}: TwinValueProps) => {
  return (
    <Column gap={gap ?? 0.4} className={cn("twin_value", className)}>
      <div
        className={cn("twin_value__one black-white-color", twinClassNames?.one)}
        style={style}
      >
        {one}
      </div>
      {copy ? (
        // <CopyText
        //   onTextToCopyClick={onTwoClick as any}
        //   text={trimLongString(two as string, 20) as string}
        //   textToCopy={textToCopy || (two as string)}
        // />
        <div
          onClick={async (e) => {
            if (stopPropagation || onTwoClick) {
              if (stopPropagation) {
                e.stopPropagation();
              }
              await onTwoClick?.();
            }
            await RazorCopyFunction({
              text: two as string,
              textToCopy: textToCopy || (two as string),
            });
          }}
          className={cn("twin_value__copy")}
        >
          {trimLongString(two as string, 20)}
        </div>
      ) : (
        <div
          onClick={(e) => {
            if (stopPropagation || onTwoClick) {
              e.stopPropagation();
              onTwoClick?.();
            }
          }}
          className={cn(
            "twin_value__two grey-white-color",
            twinClassNames?.two
          )}
        >
          {two}
        </div>
      )}
    </Column>
  );
};

export default RazorTwinValue;
